export enum Decision {
	Approved = 'Approved',
	Investigation = 'Investigation',
	Rejected = 'Rejected',
	Invalid = 'Invalid',
	Error = 'Error',
}
